import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "App-Opp-Top" }
const _hoisted_2 = { style: {"display":"flex","flex-direction":"row","align-items":"center","justify-content":"space-between","width":"100%"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  style: {"margin-left":"10px"},
  "mute-secondary": ""
}
const _hoisted_5 = {
  key: 1,
  success: ""
}
const _hoisted_6 = {
  success: "",
  "f-w-600": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_app_over_avatars = _resolveComponent("app-over-avatars")!
  const _component_el_space = _resolveComponent("el-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_space, {
      "w-100": "",
      alignment: "stretch",
      size: 12
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_app_over_avatars, { size: 50 }, _createSlots({ _: 2 }, [
            (_ctx.opportunity.createdBy)
              ? {
                  name: "one",
                  fn: _withCtx(() => [
                    _createVNode(_component_el_avatar, {
                      lazy: "",
                      src: _ctx.opportunity.createdBy.avatar,
                      icon: "el-icon-user-solid",
                      size: 45
                    }, null, 8, ["src"])
                  ]),
                  key: "0"
                }
              : undefined,
            (_ctx.opportunity.business)
              ? {
                  name: "two",
                  fn: _withCtx(() => [
                    _createVNode(_component_el_avatar, {
                      src: _ctx.opportunity.business.avatar,
                      icon: "el-icon-office-building",
                      size: 45
                    }, null, 8, ["src"])
                  ]),
                  key: "1"
                }
              : undefined
          ]), 1024)
        ]),
        _createElementVNode("div", _hoisted_2, [
          (_ctx.opportunity.business)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.opportunity.business.name), 1),
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.opportunity.business.industry) + " Industry, " + _toDisplayString(_ctx.opportunity.business.stage) + " Stage ", 1),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$moment(_ctx.opportunity.createdAt).fromNow()), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.type == 'talent')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[0] || (_cache[0] = _createElementVNode("i", {
                  class: "el-icon-top",
                  success: ""
                }, null, -1)),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$filters.boost(_ctx.opportunity.boost)), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}